import axios from 'axios'
import config from './config'

export default axios.create({
  baseURL: config.API_URL,
  headers: {
    api_key: '1D935D53-B203-4659-B274-34F03634309F',
  },
})
